// Spreading a `Headers` gives `{}`, and graphql-request 7 hands
// `requestMiddleware` a `Headers` where v6 passed a plain object.
export function headersToObject(headers: HeadersInit | undefined) {
  return Object.fromEntries(new Headers(headers).entries());
}
